// extracted by mini-css-extract-plugin
module.exports = {"trancheFlash":"TrancheWelcome_trancheFlash__AZvaE","mobile":"TrancheWelcome_mobile__8mpVx"};